/**
 * Shared constants for the marketing surface (header + footer).
 * Source of truth for outbound marketing destinations so chrome stays consistent.
 */

export const AGELESS_ADMIN_URL = "https://admin.ageless.ai";
export const AGELESS_BOOK_DEMO_URL = "https://info.ageless.ai/live-product-demo";

/**
 * Social handles surfaced in marketing chrome (footer).
 * Update here when handles change so every surface stays in sync.
 */
export const AGELESS_SOCIAL_LINKS = {
  linkedin: "https://www.linkedin.com/company/ageless-ai/",
  instagram: "https://www.instagram.com/ageless",
  youtube: "https://www.youtube.com/@get-ageless-ai",
  facebook: "https://www.facebook.com/people/Ageless-AI/61587316959064/",
} as const;
